"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=function(e,r){return{enumerable:!(e&1),configurable:!(e&2),writable:!(e&4),value:r}};exports.createPropertyDescriptor=t;
